import { render, staticRenderFns } from "./RIBusStat.vue?vue&type=template&id=21aa782b&"
import script from "./RIBusStat.vue?vue&type=script&lang=js&"
export * from "./RIBusStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports